import styled from "styled-components"

export const PageWrapper = styled.div`
    width: 100%;
    height: 100%;
`